module.exports = __webpack_public_path__ + "img/indu_active_1.42d27fc6.png";